<template>
    <div id="sidebar" class="fixed">
        <div class="sidebar-inner d-flex flex-column">
            <nav>
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <a :href="routes.home" class="nav-home nav-link" :class="{ active: isActive('home') }">
                            <span>Home</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="routes.search" class="nav-inventory nav-link" :class="{ active: isActive('search') }">
                            <span>Inventory<br />Search</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="routes.cart" class="nav-cart nav-link" :class="{ active: isActive('cart') }">
                            <span>Campaign<br />Cart</span>
                            <span v-if="counts.cart > 0" class="ml-1 badge badge-pill badge-danger">
                                {{ counts.cart }}
                            </span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="routes.orders" class="nav-orders nav-link" :class="{ active: isActive('orders') }">
                            <span>Orders</span>
                            <span v-if="counts.orders > 0" class="ml-1 badge badge-pill badge-danger">
                                {{ counts.orders }}
                            </span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="routes.calendar" class="nav-calendar nav-link"
                           :class="{ active: isActive('calendar') }">
                            <span>Calendar</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a :href="routes.favorites" class="nav-favorites nav-link"
                           :class="{ active: isActive('favorites') }">
                            <span>Favorites</span>
                            <span v-if="counts.favorites > 0" class="ml-1 badge badge-pill badge-danger">
                                {{ counts.favorites }}
                            </span>
                        </a>
                    </li>
                </ul>
            </nav>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Sidebar',

    props: {
        currentRoute: {
            type: String,
            default: '',
        },
        routes: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            counts: {
                cart: 0,
                orders: 0,
                favorites: 0,
            },
            loading: false,
        };
    },

    mounted() {
        this.loadSidebarData();

        // Listen for global events to refresh sidebar data
        Bus.$on('reloadSidebar', this.loadSidebarData);
        Bus.$on('cartUpdated', this.loadSidebarData);
        Bus.$on('orderUpdated', this.loadSidebarData);
        Bus.$on('favoriteToggled', this.loadSidebarData);
    },

    beforeDestroy() {
        // Clean up event listeners
        Bus.$off('reloadSidebar', this.loadSidebarData);
        Bus.$off('cartUpdated', this.loadSidebarData);
        Bus.$off('orderUpdated', this.loadSidebarData);
        Bus.$off('favoriteToggled', this.loadSidebarData);
    },

    methods: {
        async loadSidebarData() {
            if (this.loading) return;

            try {
                this.loading = true;

                const response = await axios.get('/api/sidebar/data');

                this.counts = {
                    cart: response.data.cart || 0,
                    orders: response.data.orders || 0,
                    favorites: response.data.favorites || 0,
                };
            } catch (error) {
                console.error('Failed to load sidebar data:', error);
            } finally {
                this.loading = false;
            }
        },

        isActive(route) {
            return this.currentRoute === route;
        },

        reload() {
            this.loadSidebarData();
        },
    },
};
</script>

<style scoped>
/* Add any sidebar-specific styles here if needed */
</style>
